import React from "react";
import "./timelineDeliveryStatus.scss";
import dateformat from "dateformat";
// Time Line
import Timeline from "@mui/lab/Timeline";
import TimelineItem, { timelineItemClasses } from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
// Time Line

const TimelineDeliveryStatus = ({ history }) => {
  return (
    <Timeline
      sx={{
        [`& .${timelineItemClasses.root}:before`]: {
          flex: 0,
          padding: 0,
        },
        transition: "all 0.5s ease",
      }}
      className="timeline-history"
    >
      {history.returning && (
        <TimelineItem>
          <TimelineSeparator>
            <TimelineDot className={history.returning && "active-dot-bar"} />
            <TimelineConnector className={history.returning && "active-dot-bar"} />
          </TimelineSeparator>
          <TimelineContent>
            <div>
              <div
                className={`status-title ${history.returning && "active-status"}`}
              >
                Return
              </div>
              <div className="date-time">
                {history.returning &&
                  dateformat(
                    new Date(history.returning),
                    "dd mmm yyyy - hh:MM TT"
                  )}
              </div>
            </div>
          </TimelineContent>
        </TimelineItem>
      )}
      <TimelineItem>
        <TimelineSeparator>
          <TimelineDot className={history.delivered && "active-dot-bar"} />
          <TimelineConnector
            className={history.delivered && "active-dot-bar"}
          />
        </TimelineSeparator>
        <TimelineContent>
          <div>
            <div
              className={`status-title ${history.delivered && "active-status"}`}
            >
              Delivered
            </div>
            <div className="date-time">
              {history.delivered &&
                dateformat(
                  new Date(history.delivered),
                  "dd mmm yyyy - hh:MM TT"
                )}
            </div>
          </div>
        </TimelineContent>
      </TimelineItem>
      <TimelineItem>
        <TimelineSeparator>
          <TimelineDot
            className={history.out_of_delivery && "active-dot-bar"}
          />
          <TimelineConnector
            className={history.out_of_delivery && "active-dot-bar"}
          />
        </TimelineSeparator>
        <TimelineContent>
          <div>
            <div
              className={`status-title ${
                history.out_of_delivery && "active-status"
              }`}
            >
              Out Of Delivery
            </div>
            <div className="date-time">
              {history.out_of_delivery &&
                dateformat(
                  new Date(history.out_of_delivery),
                  "dd mmm yyyy - hh:MM TT"
                )}
            </div>
          </div>
        </TimelineContent>
      </TimelineItem>
      <TimelineItem>
        <TimelineSeparator>
          <TimelineDot className={history.in_transit && "active-dot-bar"} />
          <TimelineConnector
            className={history.in_transit && "active-dot-bar"}
          />
        </TimelineSeparator>
        <TimelineContent>
          <div>
            <div
              className={`status-title ${history.in_transit && "active-status"}`}
            >
              In Transit
            </div>
            <div className="date-time">
              {history.in_transit &&
                dateformat(
                  new Date(history.in_transit),
                  "dd mmm yyyy - hh:MM TT"
                )}
            </div>
          </div>
        </TimelineContent>
      </TimelineItem>
      <TimelineItem>
        <TimelineSeparator>
          <TimelineDot className={history.preparing && "active-dot-bar"} />
          <TimelineConnector
            className={history.preparing && "active-dot-bar"}
          />
        </TimelineSeparator>
        <TimelineContent>
          <div>
            <div
              className={`status-title ${history.preparing && "active-status"}`}
            >
              Preparing
            </div>
            <div className="date-time">
              {history.preparing &&
                dateformat(
                  new Date(history.preparing),
                  "dd mmm yyyy - hh:MM TT"
                )}
            </div>
          </div>
        </TimelineContent>
      </TimelineItem>
      <TimelineItem>
        <TimelineSeparator>
          <TimelineDot className="active-dot-bar" />
        </TimelineSeparator>
        <TimelineContent>
          <div>
            <div className="status-title active-status">Pending</div>
            <div className="date-time">
              {history.pending &&
                dateformat(new Date(history.pending), "dd mmm yyyy - hh:MM TT")}
            </div>
          </div>
        </TimelineContent>
      </TimelineItem>
    </Timeline>
  );
};

export default TimelineDeliveryStatus;
